import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import { SocioData, AdherenteData, AdherentesResponse } from 'src/app/shared/socio-data.interface';
import { API_BASE_URL_V } from 'src/app/data-wp.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: "app-credencial",
  templateUrl: "./credencial.component.html",
  styleUrls: ["./credencial.component.css"],
})
export class CredencialComponent implements OnInit {
  constructor(
    private authSrv: AuthService,
    private http: HttpClient,
    private spinner: NgxUiLoaderService
  ) { }

  datosSocio: SocioData;
  adherentes: AdherenteData[] = [];
  loadingAdherentes = false;

  ngOnInit() {
    this.datosSocio = JSON.parse(sessionStorage.getItem("data"));
    this.obtenerAdherentes();
  }

  logout() {
    this.authSrv.logout();
  }

  obtenerAdherentes() {
    this.spinner.start();
    this.loadingAdherentes = true;
    const body = {
      afiliado: this.datosSocio.socio_numero,
      dominio: this.datosSocio.socio_dominio,
      apellido: this.datosSocio.socio_apellido
    };

    this.http.post<AdherentesResponse>(API_BASE_URL_V + "/socio/obtener-grupo-familiar", body)
      .subscribe(
        (response) => {
          this.spinner.stop();
          this.loadingAdherentes = false;
          if (response.success && response.data && response.data.resultado === 0 && response.data.miembros && response.data.miembros.length > 0) {
            // Filtrar el titular para mostrar solo los adherentes
            this.adherentes = response.data.miembros.filter(miembro =>
              miembro.socio !== this.datosSocio.socio_numero
            );
          } else {
            this.adherentes = [];
          }
        },
        (error) => {
          this.spinner.stop();
          this.loadingAdherentes = false;
          this.adherentes = [];
        }
      );
  }

  printPdf(credencialId?: string, adherente?: AdherenteData) {
    const elementId = credencialId || "credencial";
    const data = document.getElementById(elementId);

    if (!data) {
      console.error('Elemento de credencial no encontrado');
      return;
    }

    html2canvas(data).then((canvas) => {
      let fileWidth = 113;
      let fileHeight = 72;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let positionY = 30;
      let positionX = 50;
      PDF.addImage(FILEURI, 'PNG', positionX, positionY, fileWidth, fileHeight);

      // Generar nombre del archivo
      let fileName = 'credencial.pdf';
      if (adherente) {
        fileName = `credencial_${adherente.nombre}_${adherente.apellido}.pdf`;
      }

      PDF.save(fileName);
    });
  }
}
